import CustomLayout from "./wrapPageElement"
import "./src/bootstrap.min.css"
import "./src/global.scss"
import "./src/transitions.css"
import "./src/font-awesome.min.css"

export const wrapPageElement = CustomLayout
